import BaseCommunication from "../../Communication/BaseCommunication";
import store from "../../Redux/store";
//import LOGIN_ACTION from './Constants';
import {
  API_URL,
  API_BASE_URL,
  HttpMethod,
  OperationStatus,
} from "../../Communication/Constants";
import {
  VERIFY_EMAIL_SETTINGS_ACTION,
  VERIFY_OTP_SETTINGS_ACTION,
  SEND_OTP_SETTING_ACTION,
  GET_PROFILE_SETTING_ACTION,
} from "./Constants";

export default class SettingsAction extends BaseCommunication {
  getProfile(requestData, callback) {
    this.callAPI(
      GET_PROFILE_SETTING_ACTION,
      API_BASE_URL + API_URL.BASE_USER_URL + requestData.userid,
      HttpMethod.GET,
      {},
      (apiResponse) => {
        if (apiResponse.status === OperationStatus.SUCCESS) {
          if (apiResponse.data !== null) {
            store.dispatch({
              type: GET_PROFILE_SETTING_ACTION,
              response: apiResponse.data,
            });
          }
        }
        callback(apiResponse);
      }
    );
  }
  sendOTP(requestData, callback) {
    this.callAPI(
      SEND_OTP_SETTING_ACTION,
      API_BASE_URL + API_URL.v1 + API_URL.BASE_USER_URL + API_URL.SEND_OTP,
      HttpMethod.POST,
      requestData,
      (apiResponse) => {
        this.res = apiResponse;
        if (apiResponse.status === OperationStatus.SUCCESS) {
          store.dispatch({
            type: SEND_OTP_SETTING_ACTION,
            data: apiResponse.data,
          });
        }
        callback(this.res);
      }
    );
  }
  verifyOTP(requestData, callback) {
    this.callAPI(
      VERIFY_OTP_SETTINGS_ACTION,
      API_BASE_URL + API_URL.v1 + API_URL.BASE_USER_URL + API_URL.VERIFYOTP,
      HttpMethod.POST,
      requestData,
      (apiResponse) => {
        if (apiResponse.status === OperationStatus.SUCCESS) {
          store.dispatch({
            type: VERIFY_OTP_SETTINGS_ACTION,
            data: apiResponse.data,
          });
        }
        callback(apiResponse);
      }
    );
  }

  verifyGoogleEmail(requestData, callback) {
    this.callAPI(
      VERIFY_EMAIL_SETTINGS_ACTION,
      API_BASE_URL + API_URL.BASE_USER_URL + API_URL.VERIFYGOOGLE,
      HttpMethod.POST,
      requestData,
      (apiResponse) => {
        this.res = apiResponse;
        if (apiResponse.status === OperationStatus.SUCCESS) {
          store.dispatch({
            type: VERIFY_EMAIL_SETTINGS_ACTION,
            data: apiResponse.data,
          });
        }
        callback(this.res);
      }
    );
  }
}
